<template>
    <tr :class="lancamento.SaldoDia ? 'saldo-dia' : ''">
        <td align="center">{{ lancamento.Data | date("dd/LL/yyyy") }}</td>
        <td>
            {{ lancamento.Descricao }}
            <download-link :href="url_download_extrato" target="_system"  class="default-button" v-if="lancamento.Codigo && lancamento.Codigo != 0 && !previsao && lancamento.IdDocsprime==0">
                <i class="mdi mdi-camera"></i>
            </download-link>
            <a @click="showDocumentosViewer" class="default-button visible-md" v-if="lancamento.IdDocsprime && lancamento.IdDocsprime != 0 && lancamento.Codigo && lancamento.Codigo != 0 && !previsao">
                <i class="mdi mdi-camera"></i>
            </a>
            
                
            <a @click="loadDocumentos"  class="default-button visible-sm-only" v-if="!gerando_pdf && lancamento.IdDocsprime && lancamento.IdDocsprime != 0 && lancamento.Codigo && lancamento.Codigo != 0 && !previsao">
                <i class="mdi mdi-camera"></i>
            </a>
            <a  class="default-button visible-sm-only" v-if="gerando_pdf && lancamento.IdDocsprime && lancamento.IdDocsprime != 0 && lancamento.Codigo && lancamento.Codigo != 0 && !previsao">
                <i class="mdi mdi-loading mdi-spin"></i>
            </a>
            
            <div v-if="loadingDocumentos">
                <p>
                    <i class="mdi mdi-loading mdi-spin"></i>
                </p>
            </div>
            <div v-else-if="documentos && documentos.length == 0">
                <p>Nenhum documento.</p>
            </div>
            <div v-else-if="documentos && documentos.length != 0">
                <ul>
                    <Documento :documento="documento" v-for="documento in documentos" :key="documento.IdDocsprime"></Documento>
                </ul>
            </div>
            
            <DocumentosViewer @close="hideDocumentosViewer" :lancamento="lancamento" v-if="show_documentos_viewer && lancamento.IdDocsprime && lancamento.IdDocsprime!=0 && lancamento.Codigo && lancamento.Codigo != 0 && !previsao"></DocumentosViewer>
        </td>
        <td align="right">
            <!--
            <div  v-if="lancamento.ValorDebito && lancamento.ValorDebito != 0">
                <strong>Débito</strong>
                <br />
                <span class="text-red" v-raw>{{ lancamento.ValorDebito | number_format }}</span>
            </div>
            <div v-if="lancamento.ValorCredito && lancamento.ValorCredito != 0">
                <strong>Crédito</strong>
                <br />
                <span class="text-green" v-raw>{{ lancamento.ValorCredito | number_format }}</span>
            </div>
            <div v-if="lancamento.ValorSaldo && lancamento.ValorSaldo != 0">
                <strong>Saldo</strong>
                <br />
                <span :class="lancamento.ValorSaldo >= 0 ? 'text-green' : 'text-red'" v-raw>{{ lancamento.ValorSaldo | number_format }}</span>

            </div>
            -->
            <span v-if="is_debito" class="text-red" v-raw>{{ -lancamento.ValorDebito | number_format }}</span>
            <span v-if="is_credito" class="text-green" v-raw>{{ lancamento.ValorCredito | number_format }}</span>
            <span v-raw v-if="lancamento.SaldoDia" :class="lancamento.ValorSaldo<0?'text-red':'text-green'">{{ lancamento.ValorSaldo | number_format }}</span>
        </td>
        <td v-if="is_debito" align="center" class="text-red">D</td>
        <td v-if="is_credito" align="center" class="text-green">C</td>
        <td v-if="lancamento.SaldoDia" align="center" :class="lancamento.ValorSaldo < 0 ? 'text-red' : 'text-green'">{{ lancamento.ValorSaldo | saldo_debito }}</td>
    </tr>
</template>
<script>
import DocumentosViewer from './documentos-viewer.vue';
import api from '/plugins/api'
//import { pdf2jpeg } from '/plugins/pdf';


//import jsPDF from 'jspdf';
import Documento from './documento.vue';
import { api_endpoint } from '~/plugins/api';

export default {
    props: ["lancamento", "previsao"],
    components: {
        DocumentosViewer,
        Documento
    },
    filters: {
        saldo_debito(value) {
            return value < 0 ? 'D' : 'C';
        },
        number_format(value) {
            let sign = '';
            if (value < 0) {
                sign = '<b class="number-sign">-</b>'
            }
            let str = sign   + new Intl.NumberFormat("pt-BR", {
                currencySign: 'accounting',
                //currencySign: 'standard',
                style: "decimal",
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Math.abs(value));

            return str;
        },
    },
    data() {
        return {
            show_documentos_viewer: false,
            documentos: null,
            arquivos: null,
            pdf: null,
            gerando_pdf: false,
            loadingDocumentos: false,
        }
    },
    computed: {
        is_debito() {
            return Math.abs(this.lancamento.ValorDebito) > 0;
        },
        is_credito() {
            return Math.abs(this.lancamento.ValorCredito) > 0;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        jwt() {
            return this.$store.state.jwt;
        },
        url_download_extrato() {
            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin =='file://' || 'undefined' != typeof window.cordova) {                
                endpoint = window.api_endpoint;
            }
            return `${endpoint}/condominios/${this.codigo_condominio}/conta-corrente/liquid/${this.lancamento.Codigo}?jwt=${this.jwt}`;
        }
    },
    methods: {
        showDocumentosViewer() {
            this.show_documentos_viewer = true;
        },
        hideDocumentosViewer() {
            this.show_documentos_viewer = false;
        },
        async downloadDocumentos() {
            try {
                this.gerando_pdf = true;
                if (this.documentos === null) {
                    await this.loadDocumentos();
                }
                if (this.arquivos === null) {
                    
                    await this.loadArquivos();
                }

              

            } catch (err) {
                console.error(err);
            }
            this.gerando_pdf = false;
        },
        async loadDocumentos() {
            try {
                
                this.errors = [];
                this.documentos = [];
                this.loadingDocumentos = true;
                let { data: documentos } = await api.get(`condominios/${this.codigo_condominio}/conta-corrente/${this.lancamento.Codigo}/lista-documentos`);
                this.documentos = documentos;
                if (documentos.length != 0) {
                    let [documento] = documentos;
                    this.docsprime_id = documento.IdDocsprime;
                }
                
            } catch (err) {
                console.error(err);
            }
            this.loadingDocumentos = false;
            
        },
        async loadArquivos() {
            try {
                
                if (!this.documentos) {
                    return;
                }

                for(let documento of this.documentos) {
                    let IdDocsprime = documento.IdDocsprime;

                    if (!IdDocsprime) {
                        return;
                    }
                    if (!this.codigo_condominio) {
                        return;
                    }
    
    
                    let { data: arquivos } = await api.get(
                        `condominios/${this.codigo_condominio}/conta-corrente/${IdDocsprime}/lista-arquivos`
                    );
                    //const pdf2jpeg = await import('/plugins/pdf').then(e => e.pdf2jpeg);
                    const pdf2jpeg = await import('../../../plugins/pdf').then(e => e.pdf2jpeg);

                    arquivos = await Promise.all(
                        arquivos.map(({ conteudoBase64: conteudo }) =>
                            pdf2jpeg(conteudo)
                        )
                    );
                    arquivos = arquivos.reduce(
                        (acc, imagens) => [...acc, ...imagens],
                        []
                    );
                    
                    if (this.arquivos === null) {
                        this.arquivos = [];
                    }
                    this.arquivos = [...this.arquivos, ...arquivos];
                }
            } catch (err) {
                console.error(err);
            }
            
        },
        async geraPDF() {
            try {
                if (!this.arquivos) {
                    return;
                }

                const jsPDF = await import('jspdf').then(e => e.jsPDF)
                
                let doc = new jsPDF({
                    orientation: "p",
                    unit: "mm",
                    format: "a4",
                });
                doc.deletePage(1);
                for(let arquivo of this.arquivos) {
                    let img = await new Promise((resolve, reject) => {
                        let img = new Image();
                        img.onload = () => resolve(img),
                        img.onerror = reject;
                        img.src = arquivo;
                    });
                    let w = (img.width * 25) / 72;
                    let h = (img.height * 25) / 72;
                    
                    doc.addPage([Math.ceil(w ), Math.ceil(h )]);
                    
                    doc.addImage(arquivo, "JPEG", 0, 0, w, h);
                    
                }
                
                this.pdf = doc;
                
                //doc.output('pdfjsnewwindow');

            } catch (err) {
                console.error(err);
            }
        }
    }
};
</script>
<style scoped>
    tr.saldo-dia td {
        font-weight: bold;
    }
</style>